// extracted by mini-css-extract-plugin
export default {"input":"UserProfileInformation__input___z2FOp"};